import type {
  Cmd,
  ImmutableProgram,
  ImmutableResult,
  InitialProperties,
} from '@gl/lit/components/mixins/immutable_component/index.js';
import {
  Variant,
  makeVariants,
} from '@gl/lit/components/mixins/immutable_component/index.js';
import type {VariantsFor} from '@gl/lit/types/architecture.js';
import type {Nullable} from '@gl/lit/types/general.js';
import type {FlyFloatingSurfaceList} from './index.js';

export const DEFAULT_PLACEMENT = 'bottom';

export type ListItemSelection = {
  index: number;
  item: HTMLElement;
  isFirst: boolean;
  isLast: boolean;
};

export type Model = {
  active: boolean;
  selection: Nullable<ListItemSelection>;
};

export const Msg = makeVariants({
  active: Variant<boolean>()('active'),
  select: Variant<Nullable<ListItemSelection>>()('select'),
});

export type Msg = VariantsFor<typeof Msg>;

// -- Init

function init(props: InitialProperties): Readonly<Model> {
  return {
    active: <boolean>props.get('active') ?? false,
    selection: null,
  } as const;
}

// -- Update

function update(msg: Msg, model: Model, cmd: Cmd): ImmutableResult<Model> {
  switch (msg.tag) {
    case 'active': {
      return [
        {...model, active: msg.value},
        cmd((host: FlyFloatingSurfaceList) => {
          host.onActive(msg.value);
        }),
      ] as const;
    }

    case 'select': {
      const oldValue = model.selection;
      return [
        {...model, selection: msg.value},
        cmd((host: FlyFloatingSurfaceList) => {
          host.onSelection(msg.value, oldValue);
        }),
      ] as const;
    }
  }
}

// -- Program

export var main: ImmutableProgram<Model, Msg> = {
  init,
  update,
};
